import type { MenuProps } from 'antd';
import { HasRights } from '@/components/HasRights/HasRights';
import type { RbacMenuConfigItem } from './types';

export const getItems = (menuConfig: RbacMenuConfigItem[]): MenuProps['items'] =>
  menuConfig.filter((item) => HasRights([item.permission], false)).map(({ permission, ...item }) => item);
